module.exports = __webpack_public_path__ + "img/rocket-roup.869e3665.png";